import { t } from "i18next";
import Drawer from "../../../../drawer/Drawer";
import ManageCollection from "../ManageCollection";

const ManageCollectionDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl2"}
      title={
        data?._id ? (
          <span className="tracking-tighter uppercase font-bold">
            {t("Update Collection")}
          </span>
        ) : (
          <span className="tracking-tighter uppercase font-bold">
            {t("Create Collection")}
          </span>
        )
      }
      subtitle={t(
        "View, update and modify collection details and information bellow"
      )}
      drawerBodyClass="p-0 max-h-[calc(100%-90px)]"
    >
      <div className="h-full overflow-y-auto">
        <ManageCollection getResponse={getResponse} close={close} data={data} />
      </div>
    </Drawer>
  );
};

export default ManageCollectionDrawer;
